var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewTabicon = function SvgNewTabicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.496 12.978V9.067a.356.356 0 0 0-.355-.356h-.711a.356.356 0 0 0-.356.356v3.91H3.118V3.023H7.03c.196 0 .355-.159.355-.355v-.711A.356.356 0 0 0 7.03 1.6H3.118c-.785 0-1.422.637-1.422 1.422v9.956c0 .785.637 1.422 1.422 1.422h9.956c.785 0 1.422-.637 1.422-1.422Zm-.348-11.214.192.192v-.007a.533.533 0 0 1 .156.362v4.622c0 .197-.159.356-.355.356h-.711a.356.356 0 0 1-.356-.356v-2.9l-6.002 5.994a.356.356 0 0 1-.505 0l-.497-.498a.356.356 0 0 1 0-.505l6.001-6.002H9.163a.356.356 0 0 1-.356-.355v-.711c0-.197.16-.356.356-.356h4.622a.534.534 0 0 1 .363.164Z",
    clipRule: "evenodd"
  })));
};
export default SvgNewTabicon;